import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const LoggedOut = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="text-white" size={32} />
          </div>
          
          <h1 className="text-3xl font-bold mb-3">You've been logged out</h1>
          <p className="text-slate-600 mb-8">
            Your session has ended successfully. Thanks for using Keyless PMS.
          </p>
          
          <div className="space-y-3">
            <Link to="/login">
              <Button className="w-full bg-gradient-to-r from-cyan-600 to-blue-600">
                Log in again
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
            
            <a href="https://keylesspms.com" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="w-full">
                <Home className="mr-2" size={18} />
                Go to website
              </Button>
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoggedOut;